<template>
  <!-- Card 86akptec0: evolução do professor nos treinamentos exclusivos
       (módulos compartilhados só com professores). -->
  <div class="tp">
    <div class="tp__summary">
      <div class="tp__tile">
        <span class="tp__num">{{ percent }}%</span>
        <span class="tp__label">{{ $t("trainingProgress.completed") }}</span>
      </div>
      <div class="tp__tile">
        <span class="tp__num">{{ progress.completedCount || 0 }}</span>
        <span class="tp__label">{{
          $t("trainingProgress.ofLessons", {
            count: progress.totalLessons || 0,
          })
        }}</span>
      </div>
      <div class="tp__tile">
        <span class="tp__num">{{ progress.completedModules || 0 }}</span>
        <span class="tp__label">{{
          $t("trainingProgress.ofTrainings", { count: trainings.length })
        }}</span>
      </div>
    </div>

    <ul class="tp__list">
      <li v-for="item in trainings" :key="item.id" class="tp__item">
        <button type="button" class="tp__row" @click="open(item)">
          <span class="tp__title">{{ item.title }}</span>
          <span class="tp__count">
            {{ item.completedCount }}/{{ item.totalLessons }}
          </span>
        </button>
        <div
          class="tp__bar"
          role="progressbar"
          :aria-valuenow="Math.round(item.completedPercentage || 0)"
          aria-valuemin="0"
          aria-valuemax="100"
          :aria-label="item.title"
        >
          <span
            :style="{ width: (item.completedPercentage || 0) + '%' }"
          ></span>
        </div>
      </li>
    </ul>

    <div v-if="recent.length" class="tp__recent">
      <p class="tp__recent-label">{{ $t("trainingProgress.recent") }}</p>
      <ul>
        <li v-for="item in recent" :key="item.id">
          <i class="mdi mdi-check-circle"></i>
          <span>{{ item.title }}</span>
          <time>{{ formatDate(item.completedAt) }}</time>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { languageTag } from "@/plugins/i18n";

export default {
  name: "PartnerTrainingProgress",
  props: {
    // Resposta de GET /partners/trainings/progress
    progress: { type: Object, required: true },
  },
  computed: {
    trainings() {
      return this.progress.trainings || [];
    },
    recent() {
      return this.progress.recent || [];
    },
    percent() {
      return Math.round(Number(this.progress.completedPercentage) || 0);
    },
  },
  methods: {
    open(item) {
      this.$router.push(`/connect/professor/treinamentos/${item.id}`);
    },
    formatDate(value) {
      if (!value) return "";
      const date = new Date(value);
      return Number.isNaN(date.getTime())
        ? ""
        : date.toLocaleDateString(languageTag());
    },
  },
};
</script>

<style scoped>
.tp {
  font-family: "Poppins", sans-serif;
  color: var(--dk-ink, #211b2e);
}
.tp__summary {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 22px;
}
.tp__tile {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 14px 16px;
  border: 1px solid var(--dk-line, #eae7f0);
  border-radius: 14px;
}
.tp__num {
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-size: 1.8rem;
  line-height: 1;
  color: #3d5a80;
}
.tp__label {
  font-size: 12px;
  color: var(--dk-ink-soft, #6e6a79);
}
.tp__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.tp__row {
  display: flex;
  width: 100%;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding: 0;
  margin-bottom: 6px;
  border: 0;
  background: none;
  font: inherit;
  text-align: left;
  cursor: pointer;
}
.tp__row:hover .tp__title {
  color: #3d5a80;
}
.tp__row:focus-visible {
  outline: 2px solid #3d5a80;
  outline-offset: 3px;
  border-radius: 4px;
}
.tp__title {
  font-size: 14px;
  font-weight: 600;
}
.tp__count {
  font-size: 12.5px;
  color: var(--dk-ink-soft, #6e6a79);
  font-variant-numeric: tabular-nums;
}
.tp__bar {
  height: 6px;
  border-radius: 999px;
  background: #ece9f2;
  overflow: hidden;
}
.tp__bar span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #3d5a80;
}
.tp__recent {
  margin-top: 24px;
  padding-top: 18px;
  border-top: 1px solid var(--dk-line, #eae7f0);
}
.tp__recent-label {
  margin: 0 0 10px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--dk-faint, #9a96a6);
}
.tp__recent ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.tp__recent li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}
.tp__recent .mdi {
  color: var(--dk-teal, #00a379);
}
.tp__recent time {
  margin-left: auto;
  font-size: 12px;
  color: var(--dk-faint, #9a96a6);
}
@media (max-width: 600px) {
  .tp__summary {
    grid-template-columns: 1fr;
  }
}
</style>
